"use strict";
globalThis.State = (() => {
  const stores = /* @__PURE__ */ new Map();
  const subscribers = /* @__PURE__ */ new Map();
  const create = (name, initial = {}) => {
    if (stores.has(name)) return get(name);
    const state = { ...initial };
    stores.set(name, state);
    subscribers.set(name, /* @__PURE__ */ new Set());
    return get(name);
  };
  const get = (name) => {
    const state = stores.get(name);
    if (!state) return null;
    return {
      // Read value - O(1)
      get: (key) => key ? state[key] : { ...state },
      // Update and notify - O(n) where n = subscribers
      set: (key, value) => {
        const old = state[key];
        if (old === value) return;
        state[key] = value;
        notify(name, key, value, old);
      },
      // Batch update - O(n) where n = keys + subscribers
      update: (updates) => {
        const changes = [];
        Object.entries(updates).forEach(([key, value]) => {
          if (state[key] !== value) {
            const old = state[key];
            state[key] = value;
            changes.push([key, value, old]);
          }
        });
        changes.forEach(([k, v, o]) => notify(name, k, v, o));
      },
      // Reset to initial - O(n) subscribers
      reset: () => {
        const initial = stores.get(`${name}__initial`);
        if (initial) {
          Object.keys(state).forEach((k) => delete state[k]);
          Object.assign(state, initial);
          notify(name, "*", state, null);
        }
      },
      // Subscribe to changes - O(1)
      subscribe: (handler, keys = null) => {
        const sub = { handler, keys: keys ? new Set([keys].flat()) : null };
        subscribers.get(name).add(sub);
        return () => subscribers.get(name).delete(sub);
      },
      /**
       * Reset state keys for services OTHER than the selected one.
       * Prevents data pollution when switching between service flows.
       * @param {string} selectedService - The newly selected service
       */
      resetServiceData: (selectedService) => {
        const serviceKeys = globalThis.WizardConfig?.serviceStateKeys;
        if (!serviceKeys) return;
        const keysToReset = Object.entries(serviceKeys).filter(([service]) => service !== selectedService).flatMap(([, keys]) => keys);
        keysToReset.forEach((key) => {
          if (state[key] != null) {
            state[key] = key === "elements" ? [] : null;
          }
        });
      }
    };
  };
  const notify = (name, key, value, old) => {
    const subs = subscribers.get(name);
    if (!subs) return;
    subs.forEach(({ handler, keys }) => {
      if (!keys || keys.has(key) || key === "*") {
        try {
          handler(key, value, old);
        } catch (e) {
          console.error("State subscriber error:", e);
        }
      }
    });
  };
  const wizard = create("wizard", {
    service: null,
    // 'kozijnen' | 'deuren'
    step: "0",
    // Current step ID (start at postcode)
    history: [],
    // Step history for back nav
    userPostcode: "",
    // User's postcode from step 0
    // Kozijnen config
    hout: "accoya",
    glas: "hr++",
    afwerking: "gegrond",
    ral: "9016",
    montage: "alleen_kozijn",
    // Current element being configured
    currentWidth: null,
    currentHeight: null,
    currentType: "vast",
    currentVakken: 2,
    // Configured elements list
    elements: [],
    // Deuren config
    deurAfwerking: "gegrond",
    deurMontage: "compleet",
    deurOptie: null,
    deurType: null,
    deurWidth: null,
    deurHeight: null,
    // Contact
    name: "",
    email: "",
    phone: "",
    address: "",
    postcode: "",
    city: "",
    message: "",
    // Media
    files: [],
    // Estimate
    estimate: null
  });
  const cvMeasure = create("cvMeasure", {
    previewData: null,
    loading: false,
    error: null,
    result: null,
    apiData: null,
    imageData: null,
    displayCorners: null,
    originalCorners: null,
    detectionMethod: null,
    onSuccessCallback: null,
    onMultiSuccessCallback: null,
    currentFile: null
  });
  const ui = create("ui", {
    bottomsheetOpen: false,
    bottomsheetContent: null,
    mobileMenuOpen: false,
    headerShrunk: false
  });
  return Object.freeze({
    create,
    get,
    wizard,
    cvMeasure,
    ui
  });
})();
